module.exports = __webpack_public_path__ + "static/media/bitcoin-vs-SWIFT.6b6469ee.png";